import { AdminGuard } from '@/components/admin-guard'
import { createFileRoute } from '@tanstack/react-router'
import { KbAdminListView } from '@/features/kb/KbAdminListView'
import { AdminSubNav } from '@/components/shell/AdminSubNav'

function KbAdmin() {
  const { review } = Route.useSearch()
  return (
    <>
      <AdminSubNav />
      <KbAdminListView initialNeedsReview={review === 'needs_review'} />
    </>
  )
}

export const Route = createFileRoute('/admin/kb/')({
  // The Slack summary of a journey publish links here with ?review=needs_review.
  validateSearch: (raw: Record<string, unknown>): { review?: string } => ({
    review: typeof raw.review === 'string' ? raw.review : undefined,
  }),
  component: () => (
    <AdminGuard>
      <KbAdmin />
    </AdminGuard>
  ) })
